"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClauseCitationResolutionSchema = exports.PackageDataSpecClauseLineageSchema = exports.PackageDataSpecClauseSchema = exports.SpecAuthorSchema = void 0;
exports.formatClauseCitation = formatClauseCitation;
const z = require("zod");
const property_key_1 = require("../Consensus/property-key");
const package_data_spec_status_1 = require("./package-data-spec-status");
exports.SpecAuthorSchema = z.object({
    username: z.string(),
    displayName: z.string().nullable(),
});
exports.PackageDataSpecClauseSchema = z.object({
    id: z.string(),
    propertyKey: property_key_1.PropertyKeySchema,
    clauseNumber: z.number().int(),
    version: z.number().int(),
    shortName: z.string(),
    description: z.string(),
    status: package_data_spec_status_1.PackageDataSpecStatusSchema,
    isCurrentVersion: z.boolean(),
    nextVersionId: z.string().nullable(),
    replacedByClauseId: z.string().nullable(),
    retirementComment: z.string().nullable(),
    createdByUserId: z.string().nullable(),
    createdBy: exports.SpecAuthorSchema.nullable(),
    createdAt: z.date(),
    retiredByUserId: z.string().nullable(),
    retiredBy: exports.SpecAuthorSchema.nullable(),
    retiredAt: z.date().nullable(),
});
exports.PackageDataSpecClauseLineageSchema = z.object({
    propertyKey: property_key_1.PropertyKeySchema,
    clauseNumber: z.number().int(),
    versions: z.array(exports.PackageDataSpecClauseSchema),
    replacedBy: exports.PackageDataSpecClauseSchema.nullable(),
});
exports.ClauseCitationResolutionSchema = z.object({
    cited: exports.PackageDataSpecClauseSchema,
    currentVersion: exports.PackageDataSpecClauseSchema,
    replacement: exports.PackageDataSpecClauseSchema.nullable(),
});
function formatClauseCitation(clause) {
    return `${clause.propertyKey} #${clause.clauseNumber} v${clause.version}`;
}
//# sourceMappingURL=package-data-spec-clause.js.map